module.exports = __webpack_public_path__ + "static/media/objIcon.32f15372.png";